import { useTranslation } from 'react-i18next';

import { Layout, OrganizationDetails } from '../../../components/app';
import { useAccount } from '../../../features/account';
import { isAdmin } from '../../../utils';

export const OrganizationDetailsPage = () => {
  const { t } = useTranslation();
  const { account } = useAccount();

  return (
    <Layout backButton={isAdmin(account) && { title: t('organization.title.organization'), path: '/app/organization' }}>
      <OrganizationDetails className="max-w-[640px]" expanded={true} />
    </Layout>
  );
};
